import React, {useContext} from "react";
import parse from "html-react-parser";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

const cleanHtml = (text) => {
    if (!text) {
        return '';
    }

    return text
        .replace(/%brochure_signature%/g, '')
        .replace(/%shipper_signature_1%/g, '')
        .replace(/%client_signature_1%/g, '')
        .replace(/%client_signature_2%/g, '')
        .replace(/%client_signature_3%/g, '')
        .replace(/%driver_signature_2%/g, '');
};

const SignatureBox = ({signature, label}) => {
    return (
        <div className='ncbol-signature-box'>
            <div className='ncbol-signature-box-label'>{label}</div>
            {signature && signature.signature_url ?
                <>
                    <img src={signature.signature_url} alt={label} className='ncbol-signature-box-img'/>
                    <div className='ncbol-signature-box-date'>{signature.updated_at || ''}</div>
                </> : <div className='ncbol-signature-box-empty'/>}
        </div>
    );
};

const LegalRow = ({title, body, signature, label, rightFooter}) => {
    if (!body) {
        return <></>;
    }

    const cleanedBody = cleanHtml(body).replace(/^\s*:\s*/, '');

    return (
        <tr>
            <td className='ncbol-legal-left'>
                {title ? <><b>{title}</b>: </> : null}
                {parse(cleanedBody)}
            </td>
            <td className='ncbol-legal-right'>
                <SignatureBox signature={signature} label={label}/>
                {rightFooter ? <div className='mt-1'>{parse(cleanHtml(rightFooter))}</div> : null}
            </td>
        </tr>
    );
};

export default () => {
    let page = useContext(RecordsManagementContext).IV3_PageDetails || {};
    let important = page.NcBolImportantData || {};
    let signatures = page.NcBolSignatures || {};
    let summary = page.NcBolSummaryData || {};

    if (Object.keys(important).length === 0) {
        return <></>;
    }

    return (
        <div className='mt-2 ncbol-legal-wrap'>
            <div className='ncbol-brochure-banner'>
                <div className='ncbol-brochure-banner-text'>
                    {parse(cleanHtml(important.ncuc_brochure_ack_text || ''))}
                </div>
            </div>

            <div className='ncbol-sign-option-row'>
                {parse(cleanHtml(important.ncuc_brochure_subtitle_text || ''))}
            </div>

            <table className='table mb-0 ncbol-legal-table'>
                <tbody>
                <LegalRow
                    title=''
                    body={important.ncuc_binding_estimate_text}
                    signature={signatures.ncuc_shipper_sign_1}
                    label='SHIPPER SIGNATURE'
                />
                <LegalRow
                    title=''
                    body={important.ncuc_non_binding_estimate_text}
                    signature={signatures.ncuc_shipper_sign_2}
                    label='SHIPPER SIGNATURE'
                />
                <LegalRow
                    title=''
                    body={important.ncuc_no_written_estimate_text}
                    signature={signatures.ncuc_shipper_sign_3}
                    label='SHIPPER SIGNATURE'
                />
                <LegalRow
                    title=''
                    body={important.ncuc_full_value_protection_text}
                    signature={signatures.ncuc_shipper_sign_4}
                    label='SHIPPER SIGNATURE'
                    rightFooter={` ${important.ncuc_full_value_cost_text || ''}`}
                />
                <LegalRow
                    title=''
                    body={important.ncuc_basic_value_protection_text}
                    signature={signatures.ncuc_shipper_sign_5}
                    label='SHIPPER SIGNATURE'
                />

                <tr>
                    <td className='ncbol-legal-full-row' colSpan={2}>
                        {parse(cleanHtml(important.ncuc_extraordinary_value_declaration_text || ''))}
                        <div className='mt-1'><b>SHIPPER SIGNATURE:</b></div>
                        <div className='ncbol-full-sign-row'>
                            <img src={(signatures.shipper_signature_1 && signatures.shipper_signature_1.signature_url) || 'https://storage.googleapis.com/moveitpro-production/misc/default-sign-img%20.png'} alt='Shipper Signature' className='ncbol-bottom-sign-img'/>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <div className='ncbol-release-grid'>
                <div className='ncbol-release-cell'>
                    <div>{parse(cleanHtml(important.ncuc_shipper_release_text || ''))}</div>
                    <div className='mt-2'><b>SHIPPER SIGNATURE/DATE:</b></div>
                    <div className='ncbol-bottom-sign-row'>
                        <img src={(signatures.client_signature_1 && signatures.client_signature_1.signature_url) || 'https://storage.googleapis.com/moveitpro-production/misc/default-sign-img%20.png'} alt='Shipper Signature/Date' className='ncbol-bottom-sign-img'/>
                        <span className='ncbol-bottom-sign-date'>{(signatures.client_signature_1 && signatures.client_signature_1.updated_at) || ''}</span>
                    </div>
                </div>

                <div className='ncbol-release-cell'>
                    <div>{parse(cleanHtml(important.ncuc_delivery_acknowledgement_text || ''))}</div>
                    <div className='mt-2'><b>SHIPPER SIGNATURE/DATE:</b></div>
                    <div className='ncbol-bottom-sign-row'>
                        <img src={(signatures.client_signature_2 && signatures.client_signature_2.signature_url) || 'https://storage.googleapis.com/moveitpro-production/misc/default-sign-img%20.png'} alt='Delivery Signature/Date' className='ncbol-bottom-sign-img'/>
                        <span className='ncbol-bottom-sign-date'>{(signatures.client_signature_2 && signatures.client_signature_2.updated_at) || ''}</span>
                    </div>
                    <div><b>Notes:</b> {summary.move_notes || ''}</div>
                </div>
            </div>

            <div className='ncbol-release-grid'>
                <div className='ncbol-release-cell'>
                    <div>{parse(cleanHtml(important.ncuc_carrier_receipt_text || ''))}</div>
                    <div className='mt-2'><b>DRIVER SIGNATURE/DATE:</b></div>
                    <div className='ncbol-bottom-sign-row'>
                        <img src={(signatures.driver_signature_2 && signatures.driver_signature_2.signature_url) || 'https://storage.googleapis.com/moveitpro-production/misc/default-sign-img%20.png'} alt='Driver Signature/Date' className='ncbol-bottom-sign-img'/>
                        <span className='ncbol-bottom-sign-date'>{(signatures.driver_signature_2 && signatures.driver_signature_2.updated_at) || ''}</span>
                    </div>
                </div>
                <div className='ncbol-release-cell'/>
            </div>
        </div>
    );
};